import React, { FC } from 'react';
import { iconSize } from '../../../constants/icon.constants';
import Icon from '../../@shared/icon';
import Filter from './filter';
import { TSearchFilter } from '../types/search.types';

const SearchFilter: FC<TSearchFilter> = (props) => {
  const { isMobile, filterAccordionIcon, isCollapsed, filters, activeFilters, onFiltersChange, toggleCollapsed, t } = props;

  if (isMobile) {
    return (
      <div className="search__results__accordian">
        <button onClick={toggleCollapsed}>
          <h3 className="search__results__accordian--title">{t('cnhi-filters')}</h3>
          <Icon iconName={filterAccordionIcon} size={iconSize.dsk} extraClassName="search__results__accordian--title-icon" />
        </button>
        {!isCollapsed && <div className="search__results__accordian--border"></div>}
        {!isCollapsed && <Filter filters={filters} activeFilters={activeFilters} onFiltersChange={onFiltersChange} />}
      </div>
    );
  }
  return <Filter filters={filters} activeFilters={activeFilters} onFiltersChange={onFiltersChange} />;
};

export default SearchFilter;
